module.exports = __webpack_public_path__ + "mauritius.svg?d6c5b726bb6a6d6a75fcddc967c7db5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/mauritius.svg
// module id = 229
// module chunks = 10